import * as UI from "@accurx/design";
import styled from "styled-components";

const PopoverContent = styled(UI.PopoverContent)`
    padding: 0;
    min-width: 244px;
`;

const Header = styled.div`
    background-color: var(--ds-color-cloud);
    border-bottom: 1px solid var(--ds-color-silver);
    padding: 0.5rem 0.75rem;
`;

const AttachOptionsContainer = styled.div`
    padding: 0.5rem;
`;

export const StyledAttachSelector = {
    PopoverContent,
    Header,
    AttachOptionsContainer,
};
